//Generated File 
export const EDIT_LAYOUT = `editLayout`;
export const LIST_LAYOUT = `listLayout`;
export const LIST_LAYOUT_PREFERENCES = `listLayoutPreferences`;
export const META_DATA = `metaData`;
export const SEARCHER_LAYOUT = `searcherLayout`;
export const VIEW_NAMES = `viewNames`;
